import PropTypes from "prop-types";
export default PropTypes.shape({
  icon: PropTypes.string,
  name: PropTypes.string,
  contactUsUrl: PropTypes.string
})